"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceListingSchema = exports.RejectionHistoryEntrySchema = exports.ReAuthSensitiveSnapshotSchema = exports.ListingStatusSchema = exports.APosMarketplaceListingSchema = exports.APosMarketplaceListingStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosMarketplaceListingStatusSchema = zod_1.z.enum([
    'not_submitted',
    'pending_approval',
    'approved',
    'rejected',
    'changes_requested',
    'changes_pending_reapproval',
    'suspended',
]);
exports.APosMarketplaceListingSchema = zod_1.z.object({
    marketplaceId: zod_1.z.string().min(1),
    sellerTenantId: id_schema_1.TenantIdSchema,
    productId: zod_1.z.string().min(1),
    variantId: zod_1.z.string().min(1),
    mp_productId: zod_1.z.string().optional(),
    status: exports.APosMarketplaceListingStatusSchema.default('not_submitted'),
    approvedBy: zod_1.z.string().optional().describe('OWNER user id'),
    suspendedBy: zod_1.z.string().optional().describe('OWNER user id'),
    rejectionReason: zod_1.z.string().optional(),
    changeRequestNote: zod_1.z.string().optional(),
    imageHash: zod_1.z.string().optional(),
    submittedAt: zod_1.z.number().optional(),
    reviewedAt: zod_1.z.number().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
// ---------------------------------------------------------------------------
// Phase I — O13 listing state machine + delta-detection snapshot.
// Additive: distinct export names; APosMarketplaceListing* untouched.
// ---------------------------------------------------------------------------
/** O13 listing state machine (verbatim). */
exports.ListingStatusSchema = zod_1.z.enum([
    'not_submitted',
    'pending_approval',
    'approved',
    'rejected',
    'changes_requested',
    'changes_pending_reapproval',
    'suspended',
]);
/** Snapshot of approval-sensitive fields at last approval — used for delta detection. */
exports.ReAuthSensitiveSnapshotSchema = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    imageHashes: zod_1.z.array(zod_1.z.string()),
    categoryId: zod_1.z.string(),
    brand: zod_1.z.string(),
    ageRestriction: zod_1.z.boolean(),
    compliancePresetId: zod_1.z.string().optional(),
});
exports.RejectionHistoryEntrySchema = zod_1.z.object({
    at: zod_1.z.string(),
    by: zod_1.z.string(),
    reason: zod_1.z.string(),
});
/**
 * MarketplaceListing — moderation record per (marketplace, seller, product, variant).
 * PK: marketplaceId  SK: `${sellerTenantId}#${productId}#${variantId}`  GSI bySeller.
 * approvedBy/suspendedBy = OWNER user ids (UNIFIED-MODEL §5.2).
 */
exports.MarketplaceListingSchema = zod_1.z.object({
    marketplaceId: zod_1.z.string(),
    sellerTenantId: zod_1.z.string(),
    productId: zod_1.z.string(),
    variantId: zod_1.z.string(),
    mp_productId: zod_1.z.string().optional(), // set once canonical is linked
    status: exports.ListingStatusSchema,
    submittedAt: zod_1.z.string(),
    firstApprovedAt: zod_1.z.string().optional(),
    lastApprovedAt: zod_1.z.string().optional(),
    lastApprovedBy: zod_1.z.string().optional(), // = OWNER user id
    rejectionReason: zod_1.z.string().optional(),
    moderatorNotes: zod_1.z.string().optional(),
    suspendedReason: zod_1.z.string().optional(),
    suspendedAt: zod_1.z.string().optional(),
    suspendedBy: zod_1.z.string().optional(), // = OWNER user id
    lastApprovedSnapshot: exports.ReAuthSensitiveSnapshotSchema.optional(),
    resubmissionCount: zod_1.z.number(),
    rejectionHistory: zod_1.z.array(exports.RejectionHistoryEntrySchema),
});
//# sourceMappingURL=marketplace-listing.schema.js.map